"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuPanelTheme = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var mobx_react_1 = require("mobx-react");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var classnames_1 = __importDefault(require("classnames"));
var c = (0, BemBuilder_1.default)("context-menu-react");
var ContextMenuPanelTheme;
(function (ContextMenuPanelTheme) {
    ContextMenuPanelTheme["Light"] = "light";
    ContextMenuPanelTheme["Dark"] = "dark";
})(ContextMenuPanelTheme = exports.ContextMenuPanelTheme || (exports.ContextMenuPanelTheme = {}));
var ContextMenu = (0, mobx_react_1.observer)(function (_a) {
    var isOpen = _a.isOpen, onChange = _a.onChange, button = _a.button, _b = _a.actions, actions = _b === void 0 ? [] : _b, _c = _a.items, items = _c === void 0 ? [] : _c, _d = _a.panelTheme, panelTheme = _d === void 0 ? ContextMenuPanelTheme.Light : _d, _e = _a.panelSize, panelSize = _e === void 0 ? kaleidoscope_1.PopoverSize.Auto : _e;
    var _f = __read((0, react_1.useState)(isOpen !== null && isOpen !== void 0 ? isOpen : false), 2), menuOpen = _f[0], setMenuOpen = _f[1];
    var _g = __read((0, react_1.useState)(), 2), submenuOpen = _g[0], setSubmenuOpen = _g[1];
    return (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, isOpen: menuOpen, button: button, size: panelSize, theme: panelTheme === ContextMenuPanelTheme.Light ? kaleidoscope_2.PopoverTheme.Light : kaleidoscope_2.PopoverTheme.Dark, className: (0, classnames_1.default)(c("panel"), panelTheme === ContextMenuPanelTheme.Dark ? tokens_1.darkTheme : null), onChange: function (show) {
            var open = show || submenuOpen != undefined;
            setMenuOpen(open);
            onChange === null || onChange === void 0 ? void 0 : onChange(open);
        } },
        actions.length > 0 && (react_1.default.createElement("div", { className: c("actions") }, actions.map(function (action, actionIndex) { return (react_1.default.createElement(kaleidoscope_3.IconButton, __assign({ key: actionIndex }, action))); }))),
        items.length > 0 && (react_1.default.createElement("div", { className: c("menu") }, items.map(function (item, itemIndex) { return (react_1.default.createElement("div", { key: itemIndex, onMouseEnter: function () {
                setSubmenuOpen(itemIndex);
            }, onMouseLeave: function () {
                setSubmenuOpen(undefined);
            } },
            react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, isOpen: submenuOpen === itemIndex, size: kaleidoscope_1.PopoverSize.Small, position: kaleidoscope_1.PopoverPosition.Right, className: c("subpanel"), button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary }, buttonProps, { width: "full", className: c("menu-item") }),
                    item.label,
                    " ",
                    react_1.default.createElement(icons_1.ChevronRight, { size: icons_1.IconSize.Small }))); }, onChange: function (show) {
                    setSubmenuOpen(show ? itemIndex : undefined);
                }, offset: 8 }, item.panelContents))); })))));
});
exports.default = ContextMenu;
